import plantDataConfigApi from '@/api/config/plantDataConfigApi'
import { queryKeys } from '@/constant/common'
import { APIResponseList, SearchParams } from '@/types/common'
import { Plant } from '@/types/plant'
import { QueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'

function useSearchPlant(
  searchParams: SearchParams = {},
  interfaceId: number,
  queryOptions?: QueryOptions,
): UseQueryResult<APIResponseList<Plant>, any> {
  return useQuery(
    [queryKeys.plant, interfaceId, searchParams],
    async () => {
      const { data } = await plantDataConfigApi.getAll({
        interfaceId,
        ...searchParams,
      })

      if (!data) return null

      return {
        list: data?.data,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: data.totalCount,
        totalPage: data.totalPage,
      }
    },
    queryOptions,
  )
}

export default useSearchPlant
